import {
  HomeIcon,
  UsersIcon,
  ChartBarIcon,
  BanknotesIcon,
  WrenchScrewdriverIcon,
  ChatBubbleLeftRightIcon,
  UserGroupIcon,
} from '@heroicons/vue/24/outline'
import type { NavGroup } from '@/types/navigation.types'

/**
 * Sidebar navigation config.
 * Labels are i18n keys resolved at render time via $t().
 * Groups are separated by dividers in the sidebar.
 * Visibility is controlled by the `roles` array on each item/group.
 *
 * Add domain-entity items here as you build them — see
 * docs/guides/adding-entities.md → "Register in Sidebar Navigation".
 */
export const navigationGroups: NavGroup[] = [
  {
    id: 'main',
    access_levels: ['access_level.admin', 'access_level.manager', 'access_level.user'],
    items: [
      {
        routeName: 'dashboard',
        label: 'nav.home',
        icon: HomeIcon,
        access_levels: ['access_level.admin', 'access_level.manager', 'access_level.user'],
      },
      {
        routeName: 'clienti',
        label: 'nav.clienti',
        icon: UsersIcon,
        access_levels: ['access_level.admin', 'access_level.manager', 'access_level.user'],
      },
      {
        routeName: 'performance',
        label: 'nav.performance',
        icon: ChartBarIcon,
        access_levels: ['access_level.admin', 'access_level.manager', 'access_level.user'],
      },
      {
        routeName: 'incassi',
        label: 'nav.incassi',
        icon: BanknotesIcon,
        access_levels: ['access_level.admin', 'access_level.manager', 'access_level.user'],
      },
      {
        routeName: 'strumenti',
        label: 'nav.strumenti',
        icon: WrenchScrewdriverIcon,
        access_levels: ['access_level.admin', 'access_level.manager', 'access_level.user'],
      },
      {
        routeName: 'feedback',
        label: 'nav.feedback',
        icon: ChatBubbleLeftRightIcon,
        access_levels: ['access_level.admin', 'access_level.manager', 'access_level.user'],
      },
      {
        routeName: 'gestione-team',
        label: 'nav.gestione_team',
        icon: UserGroupIcon,
        access_levels: ['access_level.admin', 'access_level.manager', 'access_level.user'],
        // The page is manager+; `access_level` above is not authoritative.
        tiers: ['god', 'manager'],
      },
    ],
  },
]
